/**
 * Helper to select the entire value in a numeric input upon initial focus.
 * Uses a short timeout (50ms) to guarantee that desktop mouseup and mobile
 * touchend events do not cancel the text selection.
 *
 * @param {React.FocusEvent<HTMLInputElement>} e - React focus event.
 * @param {Function} [callback] - Optional callback executed synchronously on focus.
 */
export const handleNumericFocus = (e, callback) => {
    if (callback && typeof callback === 'function') {
        callback(e);
    }
    const target = e?.target;
    if (target) {
        setTimeout(() => {
            const isStillFocused = target.ownerDocument ? target.ownerDocument.activeElement === target : true;
            if (isStillFocused && typeof target.select === 'function') {
                target.select();
            }
        }, 50);
    }
};
